<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-crediti-imposta page-operative-data-analysis-crediti-imposta-edit">
    <div class="container">
      <PageTitle>Modifica credito</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Credito da modificare non trovato</div>
      <FormCreditiImposta v-else-if="company && userCanEdit" :credito.sync="credito" edit @saved="saveCredito" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-crediti-imposta-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormCreditiImposta: () => import('../../../../components/Operative/Form/FormCreditiImposta'),
  },
  data () {
    return {
      credito: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveCredito (credito) {
      this.$api.updateCreditoImposta(this.company.id, credito.id, credito)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.crediti-imposta',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getCreditoImposta(this.company.id, this.$route.params.creditoImpostaId)
          .then(res => {
            this.credito = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
